module.exports = __webpack_public_path__ + "static/media/r_yellow.62dcb18f.svg";